import { render, staticRenderFns } from "./VisitRecomendation.vue?vue&type=template&id=642dd930"
import script from "./VisitRecomendation.vue?vue&type=script&lang=js"
export * from "./VisitRecomendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports